// 공통 UI 라벨 (버튼, 액션, 상태 등)
const common = {
  home: '홈',
  account: '계정',
  logout: '로그아웃',
  fullscreen: '전체화면',
  fullscreenExit: '전체화면 종료',
  cancel: '취소',
  save: '저장',
  close: '닫기',
  loading: '로딩 중...',
  noData: '데이터가 없습니다',
  back: '뒤로',
  refresh: '새로고침',
  time: '시간',
};

export default common;
